
import O1HD from "../../../../../engines/gameEngine";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../../BundleResourceConfig";
import { KaoguDataHelp } from "../kaogu/config/kaoguDataHelp";
import { KaoguItemInfo } from "../kaogu/config/kaoguMountainConfig";

const { ccclass, property } = cc._decorator;

@ccclass
export default class kaoguArtcleItemBase extends cc.Component {
    @property({ type: cc.Sprite, displayName: "显示物品图片" })
    img_item: cc.Sprite = null;
    @property({ type: cc.Node, displayName: "点父节点" })
    node_PointGroup: cc.Node = null;
    @property({ type: cc.SpriteFrame, displayName: "默认图片" })
    default_sprite: cc.SpriteFrame = null
    @property({ type: cc.PolygonCollider, displayName: "泥块" })
    phy_ni: cc.PolygonCollider = null;
    @property({ type: cc.Node, displayName: "遮罩" })
    maskNode: cc.Node = null;
    pointlen = 40
    allPoints: { [id: number]: { id: number, pos: cc.Vec2, isTouch: boolean } } = {};


    niIDList: number[] = [];
    private readonly percent: number = 0.8;
    mask: cc.Mask = null;
    onLoad() {
        this.node.width = cc.winSize.width;
        this.node.height = cc.winSize.height;

        this.mask = this.maskNode.getComponent(cc.Mask);
        this.node.on(cc.Node.EventType.TOUCH_START, this.commonFunc, this);
        this.node.on(cc.Node.EventType.TOUCH_MOVE, this.commonFunc, this);
        this.node.on(cc.Node.EventType.TOUCH_END, this.touchEnd, this);
        this.node.on(cc.Node.EventType.TOUCH_CANCEL, this.touchEnd, this);
        {
            // 设立所有的点
            let startPos = cc.v2(-this.phy_ni.node.width / 2, this.phy_ni.node.height / 2);
            let maxWidthLen = Math.ceil(this.phy_ni.node.width / this.pointlen)
            let maxHeightLen = Math.ceil(this.phy_ni.node.height / this.pointlen)
            let index = 0;
            for (let i = 0; i < maxHeightLen; i++) {
                for (let j = 0; j < maxWidthLen; j++) {
                    let pos = cc.v2(startPos.x + j * this.pointlen + this.pointlen / 2, startPos.y - i * this.pointlen - this.pointlen / 2)
                    this.allPoints[index] = {
                        id: index,
                        pos: pos,
                        isTouch: false
                    }
                    // let node = new cc.Node();
                    // node.parent = this.node_PointGroup;
                    // node.setPosition(pos)
                    // node.addComponent(cc.Sprite).spriteFrame = this.default_sprite;
                    // let lab = new cc.Node().addComponent(cc.Label)
                    // lab.string = index + ""
                    // lab.node.setParent(node);
                    // lab.node.color = cc.Color.BLACK;
                    // lab.fontSize = 10
                    // lab.lineHeight = 10
                    // lab.node.setPosition(cc.v2(0, 0))
                    // lab.verticalAlign = cc.Label.VerticalAlign.CENTER
                    // lab.horizontalAlign = cc.Label.HorizontalAlign.CENTER
                    // node.width = node.height = this.pointlen - this.pointlen * 0.1

                    index++;
                }
            }

            this.refreshPointShow();
        }
        {
            // 判断图形的范围
            this.scheduleOnce(() => {
                let boxPoints: cc.Vec2[] = []; //this.phy_ni.world.points;
                for (let o of this.phy_ni.points) {
                    let pos = this.phy_ni.node.convertToWorldSpaceAR(o);
                    boxPoints.push(pos);
                }
                for (const key in this.allPoints) {
                    if (Object.prototype.hasOwnProperty.call(this.allPoints, key)) {
                        const element = this.allPoints[key];
                        if (cc.Intersection.pointInPolygon(this.node_PointGroup.convertToWorldSpaceAR(element.pos), boxPoints)) {
                            // 在包围框内
                            if (!this.niIDList.includes(element.id)) this.niIDList.push(element.id);
                        }
                    }
                }

                // this.cantouch = true;
            })
        }
    }
    nullCall: () => void = null;
    openCall: () => void = null;
    init(info: KaoguItemInfo, openCall: () => void, nullCall: () => void) {
        this.openCall = openCall;
        this.nullCall = nullCall;
        this.loadImg(info.spriteimg)
    }

    public wasSaoMiao: boolean = false;
    showSaoMiao(call: () => void) {
        if (this.wasSaoMiao) {
            return
        }
        if (this.img_item.spriteFrame == null) {
            O1HD.getModules().uiControlModule.showMessageBox("空无一物")
            call && call()
            return
        }
        this.wasSaoMiao = true;
        const node = cc.instantiate(this.img_item.node);
        this.node.addChild(node);
        node.color = cc.color(0, 0, 0);
        const t = cc.tween(node).to(0.3, { opacity: 0 }).to(0.3, { opacity: 255 })
        cc.tween(node).repeat(3, t).call(() => {
            node.destroy();
            this.wasSaoMiao = false;
            call && call()
        }).start()
    }

    async loadImg(url: string) {
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.kaogu , false);
        await new Promise<void>(resolve=>{
            bundle.load('res/kaogu/kaoguitem/' + url, cc.Texture2D, (e, ass: cc.Texture2D) => {
                if (e) {
                    resolve();
                    this.img_item.spriteFrame = null;
                    return
                }
                this.img_item.spriteFrame = new cc.SpriteFrame(ass);
                resolve();
            })
        });
       
    }

    over: boolean = false;
    cantouch: boolean = false;
    tempDrawPoints: cc.Vec2[] = [];
    readonly CLEAR_LINE_WIDTH = 80;
    touchEnd() {
        if (this.wasSaoMiao) {
            return
        }
        if (!this.cantouch) return
        if (this.over) return;
        this.tempDrawPoints = [];
        this.stopSound();
        // this.calcProgress();
    }
    commonFunc(event: cc.Event.EventTouch) {
        if (this.wasSaoMiao) {
            return
        }
        if (!this.cantouch) return
        if (this.over) return;
        this.clearMask(this.maskNode.convertToNodeSpaceAR(event.getLocation()))
    }
    play: boolean = false;
    soundID:number = null
    playSound() {
        if (this.play) return;
        this.play = true;
        O1HD.getManagers().soundMgr.playSound("kaogu/gua").then((id:number) => {
            // this.play = false;
            this.soundID = id;
            if (!this.play)this.stopSound()
        })
    }
    stopSound(){
        if(this.soundID!=null) O1HD.getManagers().soundMgr.stopSound(this.soundID)
        this.play = false;
        this.soundID = null
    }
    clearMask(pos) {
        let mask: any = this.maskNode.getComponent(cc.Mask);
        let stencil = mask._graphics;
        const len = this.tempDrawPoints.length;
        this.tempDrawPoints.push(pos);
        this.playSound()
        if (len <= 1) {
            // 只有一个点，用圆来清除涂层
            stencil.moveTo(pos.x, pos.y);
            stencil.circle(pos.x, pos.y, this.CLEAR_LINE_WIDTH / 2);
            stencil.fill();

            this.checkTouchPoint(pos);
        } else {
            // 存在多个点，用线段来清除涂层
            let prevPos = this.tempDrawPoints[len - 2];
            let curPos = this.tempDrawPoints[len - 1];

            stencil.moveTo(prevPos.x, prevPos.y);
            stencil.lineTo(curPos.x, curPos.y);
            stencil.lineWidth = this.CLEAR_LINE_WIDTH;
            stencil.lineCap = cc.Graphics.LineCap.ROUND;
            stencil.lineJoin = cc.Graphics.LineJoin.ROUND;
            stencil.strokeColor = cc.color(255, 255, 255, 255);
            stencil.stroke();

            // 记录线段经过的格子
            let distance = Math.abs(Math.floor(curPos.sub(prevPos).mag()));
            for (let num = 0; num < distance; num += this.CLEAR_LINE_WIDTH) {
                let subLocation: cc.Vec2 = curPos.sub(prevPos);
                let actualLocation = prevPos.add(subLocation.div(distance).mul(num));
                this.checkTouchPoint(actualLocation);
            }
        }
    }
    async checkTouchPoint(pos: cc.Vec2) {
        if (this.over) return;
        let openPointLen = 0;
        let maxPointLen = 0
        for (const key in this.allPoints) {
            if (Object.prototype.hasOwnProperty.call(this.allPoints, key)) {
                maxPointLen++;
                let element = this.allPoints[key];
                if (element.isTouch) {
                    openPointLen++;
                    continue;
                }
                if (element.pos.sub(pos).mag() < this.CLEAR_LINE_WIDTH / 2) {
                    element.isTouch = true;
                    openPointLen++;
                }
            }
        }
        this.refreshPointShow()

        // 油田所包含的点被揭开了多少
        let openOilPointLen = 0;
        for (let id of this.niIDList) {
            if (this.allPoints[id].isTouch) openOilPointLen++;
        }
        // console.error("油田范围：", openOilPointLen / this.oilPointIDList.length)

        // 所有的点被揭开了多少

        // console.error("所有范围：", openPointLen / maxPointLen)

        // 特殊物品揭开
        if (openOilPointLen / this.niIDList.length > this.percent) {
            console.error("物品被揭开了")
            this.over = true;
            this.stopSound();
            this.mask.node.active = false;
            if (this.img_item.spriteFrame == null) {
                O1HD.getModules().uiControlModule.showMessageBox("空无一物,你只获得一些泥巴")
                this.scheduleOnce(() => {
                    // 直接删除物件
                    this.nullCall();
                }, 2)
                return
            }
            cc.tween(this.node).to(0.3, { angle: 0 }).start()
            cc.tween(this.img_item.node).to(0.5, { x: 0, y: 150, angle: 0 }).call(() => {
                this.node.getChildByName("ef_Light_Ray").active = true;
                this.node.getChildByName("ef_Light_Ray").y = 150
            }).start()
            if (this.node.getChildByName("dibu")) {
                this.node.getChildByName("dibu").active = false
                // this.img_item.node.x=0;
                // this.img_item.node.y=0;
            }
            this.scheduleOnce(() => {
                this.node.active = false;
                this.openCall && this.openCall();
            }, 1)
        }
    }

    refreshPointShow() {
        for (const key in this.allPoints) {
            if (Object.prototype.hasOwnProperty.call(this.allPoints, key)) {
                const element = this.allPoints[key];
                if (this.node_PointGroup.children[element.id]) this.node_PointGroup.children[element.id].color = element.isTouch ? cc.Color.RED : cc.Color.WHITE;

            }
        }
    }
}